import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./index.scss";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function VideoPopup({ open, handleClose, video }) {
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#000000",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 6,
            padding: 0,
            width: "100%",
            height: "70%",
            backgroundImage: "none",
          },
        }}
      >
        <DialogContent
          className="_video_player"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <iframe
            style={{ width: "100%", height: "100%", border: "none" }}
            allow="autoplay"
            src={`${video}?autoplay=1`}
            allowFullScreen
          >
            {" "}
          </iframe>

          <CloseIcon
            color="default"
            className="_close_video_popup"
            onClick={handleClose}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
